const videoLightbox = (target) => {
  if (target) {
    new VenoBox({
      selector: '.lightbox-video'
    })
  } else {
    console.warn('Video Lightbox: No target given')
  }
}

const initLightBoxes = () => {
  const videoBoxEls = document.querySelectorAll('.lightbox-video')
  if (videoBoxEls) {
    Array.from(videoBoxEls, target => videoLightbox(target))
  }
}

export { initLightBoxes }